import { render } from "./storeListComponent.vue?vue&type=template&id=66556ba7"
import script from "./storeListComponent.vue?vue&type=script&lang=js"
export * from "./storeListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__